import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "../lib/assets";
import { Reveal } from "./Motion";

export const StayLit = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section ref={ref} data-testid="staylit-section" className="bg-black text-white px-5 sm:px-10 lg:px-16 py-20 md:py-28">
      <Reveal>
        <img src={IMG.stayLit} alt="#StayLitDieLit" className="w-full max-w-5xl mx-auto" data-testid="staylit-image" />
      </Reveal>
      <div className="mt-10 grid md:grid-cols-12 gap-8 items-end">
        <Reveal className="md:col-span-8">
          <div className="relative overflow-hidden h-[420px] md:h-[560px] [clip-path:polygon(0_0,100%_0,100%_88%,90%_100%,0_100%)]">
            <motion.img style={{ y }} src={IMG.hatPile} alt="A pile of Project X hats" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-4">
          <p className="font-mono-x uppercase text-xs tracking-[0.25em] text-[#E10600] font-bold">The stack</p>
          <p className="font-display uppercase text-5xl lg:text-6xl leading-[0.9] mt-3">Fresh batch. <br />Limited run.</p>
          <p className="mt-5 text-zinc-300 font-semibold">Every hat in this pile is going to a party near you. Grab yours before the stack runs out.</p>
        </Reveal>
      </div>
    </section>
  );
};
